module.exports = {
  apiUrl:
    process.env.NODE_ENV === "development"
      ? "http://127.0.0.1:4142"
      : "https://admin.sourcewindsoressex.com",
  getAllCountries:
    "https://restcountries.eu/rest/v2/all?fields=name;languages;callingCodes",
  weedcLink: "https://sourcewindsoressex.com/register"
};
